import gsap from 'gsap';

export default function initHeader() {
    const header = document.querySelector('.header');
    const inner = header?.querySelector('.header__inner');
    const submenus = header?.querySelectorAll('.submenu');

    if (!header || !inner || !submenus.length) return;

    // Reset state on init (for Barba transitions)
    header.classList.remove('is-active');

    const updateHeight = () => {
        let maxSubHeight = 0;

        submenus.forEach(sub => {
            const height = sub.scrollHeight;
            if (height > maxSubHeight) maxSubHeight = height;
        });


        const innerHeight = inner.offsetHeight;
        const targetBottom = -(maxSubHeight + 24); // 24px overflow

        // We set a CSS variable on the inner element
        inner.style.setProperty('--header-bg-bottom', `${targetBottom}px`);
    };

    // Prevent duplicate listeners if header is persistent
    if (header.dataset.initialized) return;
    header.dataset.initialized = "true";

    header.addEventListener('mouseenter', updateHeight);

    // Accessibility: update height when keyboard focus enters the header
    header.addEventListener('focusin', updateHeight);

    // Accessibility: Reset height when focus leaves the header completely
    header.addEventListener('focusout', (e) => {
        // If the new focused element is not inside the header
        if (!header.contains(e.relatedTarget)) {
            inner.style.setProperty('--header-bg-bottom', '-2.4rem');
        }
    });

    // Accessibility: Allow escaping the menu with ESC key
    header.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            // Remove focus from the current active element to close the menu
            document.activeElement.blur();
            inner.style.setProperty('--header-bg-bottom', '-2.4rem');
        }
    });

    // Mobile toggle
    const toggle = header.querySelector('.toggle');
    if (toggle) {
        toggle.addEventListener('click', () => {
            header.classList.toggle('is-active');
        });
    }

    // Mobile accordion
    const accordionItems = header.querySelectorAll('.mobile-nav__menu__item');
    accordionItems.forEach(item => {
        const headerArea = item.querySelector('.mobile-nav__menu__item__header');
        if (headerArea) {
            headerArea.addEventListener('click', () => {
                const isOpen = item.classList.contains('is-open');

                // Close all others
                accordionItems.forEach(otherItem => otherItem.classList.remove('is-open'));

                // Toggle current if it wasn't open
                if (!isOpen) {
                    item.classList.add('is-open');
                }
            });
        }
    });

    // Close menu when clicking on a link (for better UX with Barba)
    const mobileLinks = header.querySelectorAll('.mobile-nav__menu__submenu a');
    mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
            header.classList.remove('is-active');
        });
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
        const mobileNav = header.querySelector('.mobile-nav');
        const overlay = header.querySelector('.header-overlay');
        const isToggleClick = toggle && toggle.contains(e.target);
        const isMobileNavClick = mobileNav && mobileNav.contains(e.target);
        const isOverlayClick = overlay && overlay.contains(e.target);

        if (header.classList.contains('is-active') && !isToggleClick && !isMobileNavClick) {
            header.classList.remove('is-active');
        }
    });

    // Scroll logic
    let lastScroll = 0;
    const scrollThreshold = 50;

    const handleScroll = (scroll) => {
        const currentScroll = scroll || window.scrollY;

        // Background color
        if (currentScroll > scrollThreshold) {
            header.classList.add('header--scrolled');
        } else {
            header.classList.remove('header--scrolled');
        }

        // Show/Hide on scroll
        if (currentScroll > lastScroll && currentScroll > 200) {
            // Scrolling down
            header.classList.add('header--hidden');
        } else {
            // Scrolling up
            header.classList.remove('header--hidden');
        }

        const solutionSticky = document.querySelector('.solution-sticky');
        if (solutionSticky) {
            if (currentScroll > scrollThreshold && !header.classList.contains('header--hidden')) {
                solutionSticky.style.transform = `translateY(${header.offsetHeight}px)`;
                solutionSticky.style.transition = 'transform 0.4s var(--smooth, cubic-bezier(0.15, 0.9, 0.34, 0.95))';
            } else {
                solutionSticky.style.transform = 'translateY(0)';
            }
        }

        lastScroll = currentScroll;
    };

    if (window.lenis) {
        window.lenis.on('scroll', (e) => handleScroll(e.scroll));
    } else {
        window.addEventListener('scroll', () => handleScroll(), { passive: true });
    }

    // In case content changes or resize happens during hover
    window.addEventListener('resize', () => {
        if (header.matches(':hover')) updateHeight();
    });
}
